module.exports = __webpack_public_path__ + "static/media/5.cf1ee1a6.jpg";